/* global axios */
import ApiClient from '../ApiClient';

// The manager advisor: a question is accepted at once and answered in the
// background; the page polls the ticket until the answer lands. An answer may
// carry a plan (same id as the ticket) that the manager approves, watches and
// can undo. Voice goes to the company's AI provider through the same gate.
class TeletelAdvisorAPI extends ApiClient {
  constructor() {
    super('teletel/advisor', { accountScoped: true });
  }

  ask(question, history = []) {
    return axios.post(`${this.url}/questions`, { question, history });
  }

  status(ticket) {
    return axios.get(`${this.url}/questions/${ticket}`);
  }

  plan(id) {
    return axios.get(`${this.url}/plans/${id}`);
  }

  // confirmSensitive: the manager ticked the explicit confirmation shown
  // when the plan holds sensitive steps (messages, campaigns, roles, bulk).
  approvePlan(id, confirmSensitive = false) {
    return axios.post(`${this.url}/plans/${id}/approve`, {
      confirm_sensitive: confirmSensitive,
    });
  }

  undoPlan(id) {
    return axios.post(`${this.url}/plans/${id}/undo`);
  }

  transcribe(blob) {
    const form = new FormData();
    form.append('audio', blob, 'question.webm');
    return axios.post(`${this.url}/voice/transcriptions`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  speak(text) {
    return axios.post(
      `${this.url}/voice/speech`,
      { text },
      { responseType: 'blob' }
    );
  }
}

export default new TeletelAdvisorAPI();
